import ServerCall from "../serverCall";

const login = async (body) => {
  try {
    const response = await ServerCall.post(`/auth/admin-login`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const AuthenticationService = {
  login,
};

export default AuthenticationService;
